module.exports = __webpack_public_path__ + "img/btn_replay.d6d95d70.png";